import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

const ExploriEditWarningModal = ({ store }) => {
    const close = () => {
        store.showExploriEditWarning = false
        store.pendingExploriEdit = null
    }

    const confirm = () => {
        store.showExploriEditWarning = false
        if (store.pendingExploriEdit) {
            store.pendingExploriEdit.cb()
            store.pendingExploriEdit = null
        }
    }

    return (
        <Modal
            show={store.showExploriEditWarning}
            onClose={close}
        >
            <div id="explori-edit-warning-modal">
                <div className="uc-modal__header">
                    <h2>{i18n.t('exploriEditWarningModal.title')}</h2>
                    <p className="uc-modal__desc">
                        {i18n.t('exploriEditWarningModal.body')}
                    </p>
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        onClick={confirm}
                        cssClass="regular primary"
                        label={i18n.t('exploriEditWarningModal.confirm')}
                    />
                    <Button
                        onClick={close}
                        cssClass="regular tertiary"
                        label={i18n.t('cancel')}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default observer(ExploriEditWarningModal)
